import React from 'react';
// Assuming you might use AuthContext later for user info
// import { useAuth } from '../contexts/AuthContext';

function Checkout() {
  // const { currentUser } = useAuth(); // Example if you need user info

  const planName = "Standard Plan";
  const price = 12;
  const billingFrequency = "month";

  const handleSubscribe = (e) => {
    e.preventDefault();
    // TODO: Implement payment processing logic here
    // This would typically involve:
    // 1. Getting a payment token/method from the payment element (e.g., Stripe Elements)
    // 2. Sending the token/method ID and user info to your backend
    // 3. Your backend creates the subscription with the payment provider (Stripe, Paddle, etc.)
    // 4. Handle success or failure response from backend
    console.log("Subscribing...");
    alert("Subscription processing not yet implemented.");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-lg w-full space-y-8 bg-white dark:bg-gray-700 p-10 rounded-xl shadow-lg">
        <div>
          {/* You can replace this with your app's logo */}
          {/* <img className="mx-auto h-12 w-auto" src="/AX Logo.png" alt="Your App Logo" /> */}
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Complete Your Subscription
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-300">
            Unlock premium report writing features.
          </p>
        </div>

        {/* Order Summary */}
        <div className="border border-gray-200 dark:border-gray-600 rounded-lg p-6 space-y-4">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">Order Summary</h3>
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-300">{planName}</span>
            <span className="font-semibold text-gray-900 dark:text-white">
              ${price} / {billingFrequency}
            </span>
          </div>
          <div className="border-t border-gray-200 dark:border-gray-600 pt-4 flex justify-between items-center">
            <span className="text-lg font-semibold text-gray-900 dark:text-white">Total Due Today</span>
            <span className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              ${price}
            </span>
          </div>
        </div>

        {/* Payment Details Form */}
        <form className="mt-8 space-y-6" onSubmit={handleSubscribe}>
          <input type="hidden" name="remember" defaultValue="true" />
          <div>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Payment Details</h3>
            {/* Placeholder for Payment Element */}
            <div className="border border-gray-300 dark:border-gray-600 rounded-md p-4 bg-gray-50 dark:bg-gray-800 min-h-[100px] flex items-center justify-center">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {/* --- Secure Payment Element (e.g., Stripe Card Element) will load here --- */}
                Secure payment form loads here.
              </p>
              {/* Example: <div id="card-element"></div> */}
            </div>
            <p className="mt-2 text-xs text-gray-500 dark:text-gray-400 text-center">
              Secure payments powered by [Your Payment Provider, e.g., Stripe].
            </p>
          </div>

          {/* Billing Address (Optional - Often handled by payment provider element) */}
          {/*
          <div>
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Billing Address</h3>
            <div className="space-y-4">
              <input type="text" name="address" placeholder="Address Line 1" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />
              <input type="text" name="city" placeholder="City" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />
              <div className="flex space-x-4">
                <input type="text" name="state" placeholder="State/Province" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />
                <input type="text" name="zip" placeholder="ZIP/Postal Code" required className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white" />
              </div>
            </div>
          </div>
          */}

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-indigo-500 dark:hover:bg-indigo-600 dark:focus:ring-offset-gray-800 transition duration-150 ease-in-out"
            >
              Subscribe Now (${price}/{billingFrequency})
            </button>
          </div>

          <div className="text-center text-xs text-gray-500 dark:text-gray-400">
            By subscribing, you agree to our{' '}
            <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" className="font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300">
              Terms of Service
            </a> and acknowledge our Privacy Policy.
            You can cancel anytime.
          </div>
        </form>
      </div>
    </div>
  );
}

export default Checkout;